export function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

/**
 * @typedef {Object} Step
 * @property {number} id - Identifikátor kroku.
 * @property {boolean} required - Určuje, či je krok povinný.
 * @property {any} product - Produkt priradený k tomuto kroku, môže byť `null`.
 */
/**
 * @typedef {Object} BundleState
 * @property {number} currentStep - Aktuálny krok.
 * @property {number} bundleId - ID setu
 * @property {Object<number, Step>} steps - Objekt, kde kľúčom je číslo kroku a hodnotou je objekt typu `Step`.
 */

/**
 * Počiatočný stav, ktorý sa uloží do localStorage pri prvom spustení.
 * @type {BundleState}
 */
const initialState = {
  bundleId: null,
  currentStep: 1,
  steps: {
    1: {
      productId: 17,
      id: 1,
      required: true,
      product: null,
    },
    2: {
      productId: 6,
      id: 2,
      required: true,
      product: null,
    },
    3: {
      productId: 3,
      id: 3,
      required: true,
      product: null,
    },
    4: {
      productId: 2,
      id: 4,
      required: false,
      product: null,
    },
    5: {
      productId: 4,
      id: 5,
      required: false,
      product: null,
    },
  },
};

/**
 * Uloží počiatočný stav do localStorage, ak ešte neexistuje uložený stav.
 * @returns {void} Táto funkcia nevracia žiadnu hodnotu.
 */
export const initializeBundleBuilderState = async () => {
  try {
    if (!localStorage.getItem("customBundle")) {
      const csrfToken = getCookie("csrfToken");
      const headers = new Headers();
      headers.append("X-CSRF-TOKEN", csrfToken);
      headers.append("Accept", "application/json, text/javascript");
      headers.append("x-requested-with", "XMLHttpRequest");

      // Vytvorenie setu a nastavenie jeho ID v localStorage
      const res = await fetch("/vytvorit-set", { headers, method: "POST" });
      const body = await res.json();

      setBundleBuilderState({
        ...initialState,
        bundleId: body.bundleId,
      });
    } else if (window.location && window.location.pathname === "/vlastny-set") {
      const state = getBundleBuilderState();

      // use current step's typeId and the last chosen product id from the previous step
      // po poslednom kroku (currentStep > 5) sa typ aj produkt berú z kroku 5, rovnako ako v goToNextStep
      const lastStep = 5;
      const step = Math.min(lastStep, Math.max(1, Number(state.currentStep || 1)));
      const typeId = state.steps && state.steps[step] ? state.steps[step].productId : 0;

      const prevStep = state.currentStep > lastStep ? lastStep : step - 1;
      const prevProduct = prevStep >= 1 && state.steps && state.steps[prevStep] ? state.steps[prevStep].product : null;
      const lastProductId = prevProduct && prevProduct.id ? prevProduct.id : 0;

      // neplatný stav → reset bez presmerovania (inak by hrozil 404 alebo slučka presmerovaní)
      if (!typeId || !state.bundleId) {
        localStorage.removeItem("customBundle");
        await initializeBundleBuilderState();

        return;
      }

      // /upravit-set/{bundleId}/{typeId}/{lastProductId}
      window.location.replace(`/upravit-set/${state.bundleId}/${typeId}/${lastProductId}`);
    }
  } catch (error) {
    console.log("Chyba pri vytváraní setu:", error);
  }
};

// hlboká kópia počiatočného stavu setu
export const getInitialBundleState = () => JSON.parse(JSON.stringify(initialState));

/**
 * Získava aktuálny stav z localStorage.
 * @returns {BundleState | null} Aktuálny stav alebo `null`, ak nie je uložený žiadny stav.
 */
export const getBundleBuilderState = () => {
  const state = localStorage.getItem("customBundle");

  if (state) {
    return JSON.parse(state);
  }

  return null;
};

/**
 * Uloží daný stav do localStorage.
 * @param {BundleState} state - Stav, ktorý sa má uložiť.
 */
export const setBundleBuilderState = (state) => {
  localStorage.setItem("customBundle", JSON.stringify(state));
};

export const resetBundleBuilderState = () => {
  localStorage.removeItem("customBundle");
  initializeBundleBuilderState();

  window.location.replace("/vlastny-set");
};

/**
 * Získa objekt aktuálneho kroku.
 * @returns {Step | null} Objekt aktuálneho kroku alebo `undefined`, ak neexistuje.
 */
export const getCurrentStepBuilderState = () => {
  const state = getBundleBuilderState();
    console.log("getting current step builder state", state);

  if (!state || !state.steps) {
    return null;
  }

  return state.steps[state.currentStep];
};

// v košíku smie byť len jeden set
const cartHasBundle = () => {
  const wrapper = document.querySelector(".c-custom-bundle");

  return !!(wrapper && wrapper.dataset.cartHasBundle === "1");
};

// má rozrobený set už produkt (t.j. nezakladáme nový)?
const hasAnyProduct = (state) =>
  !!(state && state.steps && Object.keys(state.steps).some((key) => state.steps[key].product));

let pendingStepProduct = null;

// zapíše vybraný produkt do aktuálneho kroku a prejde na ďalší
const applyBundleStep = (product) => {
  const state = getBundleBuilderState();

  if (state) {
    state.steps[state.currentStep].product = product;

    if (state.currentStep <= 6) {
      state.currentStep += 1;
      setBundleBuilderState(state);
      goToNextStep();
    }
  }
};

export const updateBundleStep = (product) => {
  const state = getBundleBuilderState();

  if (!state) {
    return;
  }

  const quantity = document.querySelector(
    `input[inputoptions='product-${product.id}-quantity']`
  ).value;
  product.quantity = parseInt(quantity) || 0;

  // zakladáme nový set (prvá podlaha) a v košíku už jeden set je → upozornenie (nový nahradí pôvodný)
  if (state.currentStep === 1 && !hasAnyProduct(state) && cartHasBundle() && window.jQuery) {
    pendingStepProduct = product;
    window.jQuery("#bundle-conflict-modal").modal("show");

    return;
  }

  applyBundleStep(product);
};

/**
 * Odstráni produkt z daného kroku a ak je krok povinný, nastaví tento krok ako aktuálny.
 * @param {number} step - Číslo kroku, z ktorého sa má odstrániť produkt.
 */
export const removeProductFromBundle = (step) => {
  const state = getBundleBuilderState();

  if (state) {
    const currentStep = state.steps[step];
    state.steps[step].product = null;

    if (currentStep.required) {
      state.currentStep = currentStep.id;
    }

    setBundleBuilderState(state);
    goToPreviousStep(currentStep.id);
  }
};
/**
 * Nastaví aktuálny krok na dané číslo.
 * @param {number} step - Číslo kroku, ktorý sa má nastaviť ako aktuálny.
 */
export const setCurrentStep = (step) => {
  const state = getBundleBuilderState();

  if (state) {
    state.currentStep = step;
    setBundleBuilderState(state);
  }
};

/**
 * Získa aktuálny krok z uloženého stavu.
 * @returns {Step | null} Aktuálny krok alebo `null`, ak neexistuje žiadny stav.
 */
export const getCurrentStep = () => {
  const state = getBundleBuilderState();
  console.log("getting current step", state);

  if (state) {
    return state.steps[state.currentStep] || null;
  }

  return null;
};

const goToNextStep = () => {
  const state = getBundleBuilderState();

  if (state) {
    if (state.currentStep <= 5) {
      const nextStepTypeId = state.steps[state.currentStep].productId;

      // Presmerovanie kvoli prefiltrovaniu produktov podľa typu dalsieho kroku
      window.location.href = `/upravit-set/${
        state.bundleId
      }/${nextStepTypeId}/${state.steps[state.currentStep - 1].product.id}`;
    } else if (state.currentStep === 6) {
      // Handle last step
      const thisStepTypeId = state.steps[state.currentStep -1 ].productId;

      window.location.href = `/upravit-set/${
          state.bundleId
      }/${thisStepTypeId}/${state.steps[state.currentStep -1].product.id}`;
    }
  } else {
    window.location.href = "/vlastny-set";
  }
};

const goToPreviousStep = (targetStep) => {
  const state = getBundleBuilderState();

  if (state) {
    // ensure targetStep is within bounds (>= 1)
    const step = Math.max(1, Number(targetStep || state.currentStep - 1));

    const typeId = state.steps[step].productId;
    const prevProduct = state.steps[step - 1] ? state.steps[step - 1].product : null;
    const prevProductId = prevProduct && prevProduct.id ? prevProduct.id : 0;

    // set current step and persist locally
    state.currentStep = step;
    setBundleBuilderState(state);

    // redirect similar to next step, but targeting the chosen step
    window.location.href = `/upravit-set/${state.bundleId}/${typeId}/${prevProductId}`;
  } else {
    window.location.href = "/vlastny-set";
  }
};

// pôvodný set v košíku nahradí backend (v košíku ostane len jeden)
export const addBundleToCart = async () => {
  try {
    const csrfToken = getCookie("csrfToken");
    const headers = new Headers();
    headers.append("X-CSRF-TOKEN", csrfToken);
    headers.append("Accept", "application/json, text/javascript");
    headers.append("x-requested-with", "XMLHttpRequest");
    headers.append("Content-Type", "application/json");

    const res = await fetch("/pridat-vlastny-set-do-kosika", {
      headers,
      method: "POST",
      body: JSON.stringify(getBundleBuilderState()),
    });

    if (!res.ok) {
      throw new Error("Set sa nepodarilo uložiť (" + res.status + ")");
    }

    localStorage.removeItem("customBundle");
    window.location.href = "/nakupny-kosik";
  } catch (error) {
    console.log("Chyba pri pridávaní setu do košíka:", error);
  }
};

const onReady = (fn) => {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
};

// "Nahradiť novým setom" potvrdí výber prvej podlahy (Ponechať len zavrie modal)
onReady(() => {
  const confirmBtn = document.querySelector(".js-bundle-replace-confirm");

  if (confirmBtn) {
    confirmBtn.addEventListener("click", () => {
      if (window.jQuery) {
        window.jQuery("#bundle-conflict-modal").modal("hide");
      }

      if (pendingStepProduct) {
        applyBundleStep(pendingStepProduct);
      }
    });
  }
});

window.updateBundleStep = updateBundleStep;
